import { ItemType, MenuItemType } from 'antd/es/menu/interface'
import MainContentLayout from '../../components/MainContentLayout'
import { PlaylistsRouter, TracksRouter } from '../../utils/routes/MusicRoutes'
import { ClientsRouter } from '../../utils/routes/UsersRoutes'
import { Button, Checkbox, Flex, Form, Input, message } from 'antd'
import { attemptCreateUser, RegistrationDTO } from '../../utils/redux/usersSlice'
import { listenerMiddleware, store, useAppDispatch } from '../../utils/redux/store'
import { useAttemptListener } from 'dev-masters-react-kit'
import { useNavigate } from 'react-router-dom'
import PhoneNumberInput from '../../components/PhoneNumberInput'

//"eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiI2N2E0ODYzZTk5M2E4ZmMwNGVlNGYxMjQiLCJlbWFpbCI6ImRldkBkZXYuY29tIiwibmFtZSI6Ik5ldyB1c2VyIiwiaWF0IjoxNzM4ODM1NTE4LCJleHAiOjE3NzAzNzE1MTh9.WY52aZqrsaVs5xkTRuhZDmYdM6LSfHG95YLezFFrlSI"
//dev@dev.com
//dev@dev.com
export default function NewClient() {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()

  function onFinish(values: RegistrationDTO) {
    dispatch(attemptCreateUser(values))
  }

  const isLoading = useAttemptListener({
    listenerMiddleware: listenerMiddleware,

    attempt: attemptCreateUser,
    onFulfilled: () => {
      message.success('User has been created successfully!')
      navigate('/users/clients/all')
    },
    onRejected: (action) => message.error(action.error.message),
  })

  return (
    <Form
      onFinish={onFinish}
    >
      <Form.Item
        name="name"
        rules={[{ required: true, message: 'Please input customer name!' }]}
      >
        <Input placeholder="Name" />
      </Form.Item>

      <Form.Item
        name="email"
        rules={[
          { required: true, message: 'Please input your email!' },
          { type: 'email', message: 'Invalid email, example: user@gmail.com!' },
        ]}
      >
        <Input placeholder="Email" />
      </Form.Item>

      <Form.Item
        name="password"
        rules={[{ required: true, message: 'Please input your password!' }]}
      >
        <Input.Password placeholder="Password" />
      </Form.Item>

      <Form.Item
        name="phone"
        rules={[{ required: true, message: 'Please input your password!' }]}
      >
        <PhoneNumberInput/>
      </Form.Item>
      <Form.Item
        name="city"
        rules={[{ required: true, message: 'Please provide customer city!' }]}
      >
        <Input placeholder="City" />
      </Form.Item>
      <Form.Item
        name="businessType"
        rules={[{ required: true, message: 'Please provide customer business type!' }]}
      >
        <Input placeholder="Business type" />
      </Form.Item>
      <Form.Item
        name="identifier"
        rules={[{ required: true, message: 'Please provide customer identifier!' }]}
      >
        <Input placeholder="Identifier" />
      </Form.Item>
      <Form.Item>
        <Button type="primary" htmlType="submit" block loading={isLoading}>
          Create
        </Button>
      </Form.Item>
    </Form>
  )
}
